import React from "react";
import { useEffect } from 'react';
import { dateWithTimeZone } from "../../../../../../utilities/utils";

const utmCampaignValue = 'hardsellseedtag';
const utmSourceValue = 'phd';

export const SeedTagVisitPixel = ({ model }) => {
    
    useEffect(() => {
        let expirationDate = new Date("2025-03-01");//YYYY-MM-DD
        const utmCampaign = sessionStorage.getItem("utm_campaign");
        const utmSource = sessionStorage.getItem("utm_source");

        const model1 = 'Q3';
        const model2 = 'Q5';

        if( dateWithTimeZone() < expirationDate && utmCampaign === utmCampaignValue && utmSource === utmSourceValue ) {
            if (model?.name === model1 || model?.name === model2) {

                if(document.getElementById('phd-seedtag-visit-ns-pixel-script')) return;
                
                if ( model.name === model1){
                    // let code        = ` gtag('event', 'conversion', {
                    //                     'allow_custom_scripts': true,
                    //                     'u2': '[URL_Info]',
                    //                     'send_to': 'DC-10089018/invmedia/mx_au004+standard'
                    //                 });`

                    // const script    = document.createElement('script');
                    // script.id       = 'phd-seedtag-visit-pixel-script';
                    // script.text     = code;

                    // document.body.appendChild(script);

                    
                    const script1     = document.createElement('img');
                    script1.id        = 'phd-seedtag-visit-ns-pixel-script';
                    script1.src       = 'https://ad.doubleclick.net/ddm/activity/src=10089018;type=invmedia;cat=mx_au004;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ord=1?'
                    script1.width     = 1;
                    script1.height    = 1;
                    script1.style     = 'display: none';

                    document.body.appendChild(script1);
                } else if (model.name === model2) {
                    // let code        = ` gtag('event', 'conversion', {
                    //                         'allow_custom_scripts': true,
                    //                         'send_to': 'DC-10089018/invmedia/mx_au006+standard'
                    //                     });`

                    // const script    = document.createElement('script');
                    // script.id       = 'phd-seedtag-visit-pixel-script';
                    // script.text     = code;

                    // document.body.appendChild(script);

                    
                    const script1     = document.createElement('img');
                    script1.id        = 'phd-seedtag-visit-ns-pixel-script';
                    script1.src       = 'https://ad.doubleclick.net/ddm/activity/src=10089018;type=invmedia;cat=mx_au006;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ord=1?'
                    script1.width     = 1;
                    script1.height    = 1;
                    script1.style     = 'display: none';

                    document.body.appendChild(script1);
                }
                
            }
        }
    }, [model]);
    

    return (<></>);
};

export default SeedTagVisitPixel;